module.exports = __webpack_public_path__ + "img/veneer.5b239661.jpg";